const menusSelector = (state) => state.menus;

export default menusSelector;
